import { render, staticRenderFns } from "./ListPrimaryWholesales.vue?vue&type=template&id=85867432&scoped=true&"
import script from "./ListPrimaryWholesales.vue?vue&type=script&lang=ts&"
export * from "./ListPrimaryWholesales.vue?vue&type=script&lang=ts&"
import style0 from "./ListPrimaryWholesales.vue?vue&type=style&index=0&id=85867432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85867432",
  null
  
)

export default component.exports